// extracted by mini-css-extract-plugin
export default {"container":"MobilePurpleBall_container__DT14P"};